import { useAuthUser } from "Components/Auth/hooks/useAuthUser";
import { useCompany } from "../../Company/hooks/useCompany";
import { getMemberRole } from "../helpers/getMemberRole";

export const useMemberRole = () => {
	const userId = useAuthUser((state) => state.user?.uid);
	const companyRole = useCompany((state) =>
		getMemberRole({ company: state.item, userId })
	);

	return companyRole;
};
